// @ts-nocheck
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks"; // Store Custom Code
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    type: "Product" | "Generic";
    modalIsOpen?: boolean;
    extendedStyles?: PriceSpiderWhereToBuyStyles;
}

type Props = OwnProps & HasProduct;

export interface PriceSpiderWhereToBuyStyles {
    wrapper?: InjectableCss;
}

const priceSpiderWhereToBuyStyles: PriceSpiderWhereToBuyStyles = {
    wrapper: {
        css: css`
            display: flex;

            .ps-widget {
                width: 100%;
            }
        `,
    },
};

const PriceSpiderWhereToBuy = ({ type, modalIsOpen, product, extendedStyles }: Props) => {
    const [styles] = React.useState(() => mergeToNew(priceSpiderWhereToBuyStyles, extendedStyles));
    const isSignedIn = useIsSignedInAndhasToBeSignedIn();
    const [isVariantParent, setIsVariantParent] = useState<boolean | undefined>(undefined);
    const prevPsSku = useRef<string | undefined>(undefined);
    const psWidgetRef = useRef();
    const [productNumber, setProductNumer] = useState<string | undefined>(undefined);
    const { isInShell } = useShellContext();

    if (!type) {
        return null;
    }

    if (type === "Product") {
        useEffect(() => {
            setIsVariantParent(product.isVariantParent);

            if (product && product.isVariantParent) {
                prevPsSku.current = undefined;
                setProductNumer(undefined);
            } else {
                prevPsSku.current = product.productNumber;
                setProductNumer(product.productNumber);
            }
        }, [product.isVariantParent, product.productNumber]);

        useLayoutEffect(() => {
            if (!isInShell) {
                if (window.PriceSpider) {
                    window.PriceSpider.rebind();
                }
            }
        }, [productNumber]);
    }

    if (type === "Generic") {
        setTimeout(() => {
            if (window.PriceSpider) {
                /**
                 * This forces a rerender in addition to the rebind method.
                 */
                scrollBy(0, 1); // eslint-disable-line no-restricted-globals
                scrollBy(0, -1); // eslint-disable-line no-restricted-globals
                window.PriceSpider.rebind();
            }
        }, 0);
    }

    const isActiveProduct = !isVariantParent && !!productNumber;

    if (type === "Generic" && !product) {
        return (
            <StyledWrapper {...styles.wrapper}>
                <div className="ps-widget" data-test-selector="priceSpiderGenericDiv"></div>
            </StyledWrapper>
        );
    }

    return type === "Product" && product && !isSignedIn && isActiveProduct ? (
        <StyledWrapper {...styles.wrapper}>
            <div
                className="ps-widget"
                ps-sku={productNumber}
                ref={psWidgetRef as any}
                style={{ display: `${isActiveProduct ? "block" : "none"}` }}
                data-test-selector="priceSpiderProductDiv"
            ></div>
        </StyledWrapper>
    ) : null;
};

export default withProduct(PriceSpiderWhereToBuy);
